import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "mt-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl px-8 py-2 text-gray-400" }, "Basılması Gereken Faturalar", -1)
const _hoisted_3 = { class: "flex flex-col space-y-2 w-full p-8" }
const _hoisted_4 = {
  key: 0,
  class: "table-auto"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Id"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Users e-Mail"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Users Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "Amount"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "Created"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Package"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Actions")
  ])
], -1)
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-right" }
const _hoisted_10 = { class: "text-right" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn-one" }, "Details")
], -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "p-5" }, null, -1)
const _hoisted_21 = { class: "flex flex-col space-y-2 w-full p-8" }
const _hoisted_22 = { class: "flex flex-row flex-wrap" }
const _hoisted_23 = { class: "p-2" }
const _hoisted_24 = { class: "text-xl text-gray-500" }
const _hoisted_25 = { class: "text-sm" }
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("input", {
      type: "file",
      id: "file",
      ref: "file",
      multiple: "",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleFileUpload())),
      style: {"position":"absolute","top":"-500px"},
      accept: "application/pdf"
    }, null, 544),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.items)
        ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.receiptId
                }, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(item.receiptId), 1),
                  _createElementVNode("td", _hoisted_7, _toDisplayString(item.receiptAddressPersonFirstName), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(item.receiptAddressPersonLastName), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(item.price), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(item.receiptCreatedDate), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(item.receiptType), 1),
                  _hoisted_12,
                  _hoisted_13,
                  _hoisted_14,
                  _hoisted_15,
                  _createElementVNode("td", _hoisted_16, _toDisplayString(item.receiptNumber), 1),
                  _hoisted_17,
                  _hoisted_18
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, "No Record.")),
      _hoisted_20
    ]),
    _createElementVNode("div", _hoisted_21, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.receiptId,
          class: "bg-gray-100 p-4 space-y-4"
        }, [
          _createElementVNode("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                key: column,
                class: _normalizeClass([item[column] !== undefined && item[column] !== null && item[column].length > 0 ? 'w-1/6' : ''])
              }, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(column), 1),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(item[column] || "BOŞ"), 1)
                ])
              ], 2)), [
                [_vShow, _ctx.dontShowColumns.some((x) => x === column) === false && item[column] !== undefined && item[column] !== null && item[column].length > 0]
              ])
            }), 128))
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": ($event: any) => ((item.receiptNumber) = $event),
            placeholder: "Fatura no",
            class: "border border-blue-300 outline-none focus:outline-none px-1 py-1 mr-2"
          }, null, 8, _hoisted_26), [
            [_vModelText, item.receiptNumber]
          ]),
          _createElementVNode("button", {
            class: "outline-none focus:outline-none bg-blue-400 my-auto px-2 py-1 rounded text-white",
            onClick: ($event: any) => (_ctx.addFile(item))
          }, "Fatura Ekle", 8, _hoisted_27)
        ]))
      }), 128))
    ])
  ]))
}